import {useDispatch} from "react-redux";
import {useEffect, useState} from "react";
import {DOCUMENT_MODEL} from "../../Model/Models";
import {PROFILE_MODEL} from "../../../../DocumentationApprovalFlow/Model/Model";
import {
    GetActiveDocumentUserList,
    GetActiveDocumentVehicleList
} from "../../../../../reduxToolkit/DocumentationApproval/DocumentationApprovalApi";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

// Main component for managing contractor access rights
const DocumentationTabApp = ({
    id,
    profile,
    userTypeId
}) => {
    const dispatch = useDispatch();
    const [documentationData, setDocumentationData] = useState([]);

    useEffect(() => {
        if(id) getActiveDocumentation();
    }, [id]);

    const getActiveDocumentation = () => {
        let body;
        let endPoint;
        if(profile === PROFILE_MODEL.VEHICLE){
            body = {
                userTypeId,
                vehicleId: id,
                profile
            }
            endPoint = GetActiveDocumentVehicleList;
        }else{
            body = {
                userTypeId,
                userId: id,
                profile
            }
            endPoint = GetActiveDocumentUserList;
        }

        dispatch(endPoint(body)).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    const list = data.map((d) => DOCUMENT_MODEL.toSet(d));
                    setDocumentationData(list);
                }
            },
        );
    };

    // Return necessary values and state setters to be used by components consuming this logic
    return {
        documentationData
    };
}

// Export the component for use in other parts of the application
export default DocumentationTabApp;
